import React, { forwardRef } from 'react';
import { classNames } from '@/utils';

export interface ProgressProps extends React.ComponentPropsWithoutRef<'div'> {
  /** Percent of filled bar (0-100) */
  value: number;
  /* Progress color */
  color: 'primary' | 'success' | 'danger';
  /** Text to be placed aside the progress bar */
  label?: string;
}

export const Progress = forwardRef<HTMLDivElement, ProgressProps>(({ className, value, color, label }, ref) => {
  return (
    <div className={classNames('progress-container', className)} ref={ref}>
      <figure className={classNames('progress', color)}>
        <span className="progress-level" style={{ width: `${value}%` }} />
      </figure>
      <p data-role="progress-value">{label}</p>
    </div>
  );
});

Progress.displayName = 'Progress';
